"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Represents the mode of color transformation
 */
var ColorTransformDirection;
(function (ColorTransformDirection) {
    /**
     * Transform from light to dark
     */
    ColorTransformDirection[ColorTransformDirection["LightToDark"] = 0] = "LightToDark";
    /**
     * Transform from dark to light
     */
    ColorTransformDirection[ColorTransformDirection["DarkToLight"] = 1] = "DarkToLight";
})(ColorTransformDirection = exports.ColorTransformDirection || (exports.ColorTransformDirection = {}));
//# sourceMappingURL=ColorTransformDirection.js.map